import React from 'react';
import App, { IAppProps } from './measure_shared/App';
import { appHistory, AppHistoryEntry } from './measure_shared/AppHistory';

import { filters } from './measure_shared/filters_common';
import { blobToSrc, fileToSrc, getSrcString, getThumbString, isInternal, openDialog, openLink, saveDialog } from './tools_web';

import defaultCollection from './auto_generated/default.json';
import licences from './auto_generated/licenses.json';
import { generateLicenseList } from './measure_shared/license/Licenses';
import { commonOptions, languageKeyList, LanguageKeys, OptionsType } from './measure_shared/CommonTypes';
import { parseOpts, srcEnding } from './measure_shared/options';
import { imagesPath } from './constants_web';

type WebAppState = IAppProps;

const validExtensions = ['.jpg', '.jpeg', '.png', '.tif', '.tiff'];

let defaultOpts: OptionsType = {};

try {
  const url = new window.URL(document.location.href);
  const post = url.hostname.split('.').pop()!;
  if (languageKeyList.includes(post))
    defaultOpts.lang = post as LanguageKeys;
  else if (['com', 'co.uk', 'eu'].includes(post))
    defaultOpts.lang = 'en';
  defaultOpts = {
    ...defaultOpts,
    ...parseOpts([...url.searchParams].map(p => p.join('=')), [...commonOptions, 'collection'])
  };
} catch (error) {
  console.log(`Error parsing options: ${error}`);
}

export default class WebApp extends React.Component<{}, WebAppState> {
  private saveHist = (entry: AppHistoryEntry, createNew: boolean) => {
    const url = new URL(window.location.href);
    if (entry.data) {
      if (entry.data.imageSrc) {
        const src = entry.data.imageSrc;
        if (isInternal(src.src)) {
          url.searchParams.delete('src');
          url.searchParams.set('id', src.id!);
        } else if (src.src.startsWith('http')) {
          url.searchParams.delete('id');
          url.searchParams.set('src', `${src.name}${srcEnding}`);
        } else {
          url.searchParams.delete('src');
          url.searchParams.delete('id');
        }
      }
      url.searchParams.set('lang', entry.data.settings.lang);
    }
    if (createNew) {
      window.history.pushState(entry.data, '', url);
    } else {
      window.history.replaceState(entry.data, '', url);
    }
  };

  private onPopState = () => {
    appHistory.restore(appHistory.getCurrent());
  };

  private loadCollection = async () => {
    let collection = defaultCollection;
    if (defaultOpts.collection) {
      try {
        collection = await (await fetch(`${imagesPath}/${defaultOpts.collection}.json`, { cache: 'no-cache' })).json();
      } catch (err) {
        console.log(`Error loading collection: ${err}`);
      }
    }
    this.setState({ props: { ...this.state.props, collection } });
  };

  constructor(props: {}) {
    super(props);


    this.state = {
      props: {
        collection: { categories: [], images: []}, filters, validExtensions,
        licenses: generateLicenseList(Object.entries(licences)),
      },
      utils: {
        getSrcString, getThumbString, getDefaultOpts: () => defaultOpts,
        openDialog, saveDialog, fileToSrc, blobToSrc, openLink
      }
    };
  }

  componentDidMount() {
    appHistory.getCurrent = () => ({ data: window.history.state ? window.history.state : undefined });

    appHistory.addSaveListener(this.saveHist);
    window.addEventListener('popstate', this.onPopState);

    const old = appHistory.getCurrent();
    if (old.data) {
      appHistory.restore(old);
    } else {
      appHistory.restore({ opts: defaultOpts });
    }
    this.loadCollection();
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.onPopState);
    appHistory.removeSaveListener(this.saveHist);
  }


  public render() {
    return <App {...this.state} />;
  }
}
